import React from 'react';
import { Button, Box, Typography } from '@material-ui/core';
import { 
  Theme,
  CustomArrowBackIcon,
  SnackBar,
  Loader,
  SelectedMembersSection,
  SettingsSection,
} from '@orijinworks/frontend-commons';

// MODAL_CONTEXTS constant (since it's not exported from package)
const MODAL_CONTEXTS = {
  CHANNEL: 'channel',
  ANNOUNCEMENT: 'announcement',
  MESSAGE: 'message',
  EDIT: 'edit',
};
import AttorneyAutocomplete from './AttorneyAutocomplete';
import { useAttorneyModalHook } from './useAttorneyModalHook';
import {
  mainContainer,
  SnackBarComponent,
  headerContainer,
  closeButton,
  headerTitle,
  headerTextContainer,
  contentContainer,
  membersSection,
  footerContainer,
  getCreateButtonStyles,
  cancelButton,
} from './AttorneyModal.styles';

const AttorneyModal = ({
  onClose,
  onCreateConversation,
  maximumMembersAllowed = 10,
  isCreateLoading = false,
  showDisplayNamesOnly = false,
  initialConversationSettings = {},
}) => {
  const {
    memberOptions: filteredMemberOptions,
    selectedMembers,
    learnerCanSendMessages,
    limitLearnerMessages,
    numberOfMessages,
    shutDownConversation,
    isMaxMembersReached,
    memberSelectionError,
    isMemberSearchLoading,
    setLearnerCanSendMessages,
    setLimitLearnerMessages,
    setNumberOfMessages,
    setShutDownConversation,
    handleRemoveMember,
    handleMembersChange,
    handleSearchChange,
    handleCreateConversation,
    getOptionLabel,
    filterOptions,
    isOptionEqualToValue,
    getButtonDisabledState,
  } = useAttorneyModalHook({
    onCreateConversation,
    maximumMembersAllowed,
    initialConversationSettings,
    isCreateLoading,
  });

  return (
    <Theme>
      <Box sx={mainContainer}>
        <Box sx={SnackBarComponent}>
          <SnackBar hideCrossIcon={true} />
        </Box>

        {/* Header */}
        <Box sx={headerContainer}>
          <Box
            onClick={onClose}
            sx={closeButton}
            role="button"
            aria-label="close"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClose();
              }
            }}
          >
            <CustomArrowBackIcon size={24} fill="#0F48B8" />
          </Box>
          <Box sx={headerTextContainer}>
            <Typography variant="h6" style={headerTitle}>
              Create a New Attorney Conversation
            </Typography>
          </Box>
        </Box>

        {/* Content Area */}
        <Box sx={contentContainer}>
          {/* Members Section */}
          <Box sx={membersSection}>
            <AttorneyAutocomplete
              memberOptions={filteredMemberOptions}
              selectedMembers={selectedMembers}
              onMembersChange={handleMembersChange}
              onSearchChange={handleSearchChange}
              isMaxMembersReached={isMaxMembersReached}
              memberSelectionError={memberSelectionError}
              isMemberListLoading={isMemberSearchLoading}
              showDisplayNamesOnly={showDisplayNamesOnly}
              filterOptions={filterOptions}
              getOptionLabel={getOptionLabel}
              isOptionEqualToValue={isOptionEqualToValue}
            />

            {/* Selected Members Display Section */}
            <SelectedMembersSection
              selectedMembers={selectedMembers}
              memberOptions={filteredMemberOptions}
              onRemoveMember={handleRemoveMember}
              hideCountMessage={true}
            />
          </Box>

          {/* Settings Section */}
          <SettingsSection
            modalContext={MODAL_CONTEXTS.MESSAGE}
            learnerCanMessagesInFeed={false}
            learnerCanReplyInThread={false}
            limitLearnerReplies={false}
            channelNumberOfMessages={0}
            learnerCanSeeOthersResponses={false}
            learnerCanSendMessages={learnerCanSendMessages}
            limitLearnerMessages={limitLearnerMessages}
            numberOfMessages={numberOfMessages}
            shutDownConversation={shutDownConversation}
            setLearnerCanSendMessages={setLearnerCanSendMessages}
            setLimitLearnerMessages={setLimitLearnerMessages}
            setNumberOfMessages={setNumberOfMessages}
            setShutDownConversation={setShutDownConversation}
          />
        </Box>

        {/* Footer with Action Buttons */}
        <Box sx={footerContainer}>
          {isCreateLoading ? (
            <Loader isLoading={true} />
          ) : (
            <>
              <Button
                variant="contained"
                style={getCreateButtonStyles(getButtonDisabledState())}
                disabled={getButtonDisabledState()}
                onClick={handleCreateConversation}
              >
                Create Conversation
              </Button>
              <Button variant="outlined" style={cancelButton} onClick={onClose}>
                Cancel
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Theme>
  );
};

export default AttorneyModal;

